import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { BreadcrumbItem } from "@obg/core.breadcrumb";

@Component({
	selector: "obg-compact-breadcrumb",
	templateUrl: "compact-breadcrumb.component.html",
	styleUrls: ["./compact-breadcrumb.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CompactBreadcrumbComponent {
	@HostBinding("class.obg-compact-breadcrumb") hostCssClass = true;

	@Input() breadcrumbList: BreadcrumbItem[] | undefined;

	trackByItem(_index: number, item: BreadcrumbItem) {
		return item.route;
	}
}
